// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import '@/utils/flexible.js'
// 全局方法
// import Common from './utils/common'
// Vue.prototype.Common = Common;
import VueI18n from 'vue-i18n';

Vue.use(ElementUI);
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale:  'en', //使用localStorage缓存到本地localStorage.getItem('language') ||，当下次使用时可默认当前使用语言
  messages: {
    'zh': require('./common/lang/zh'),
    'en': require('./common/lang/en')
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js